import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import LabTestDirectory from './LabTestDirectory';

const LabRouteHandler = () => {
  const { identifier } = useParams();
  const [loading, setLoading] = useState(true);
  const [redirectTo, setRedirectTo] = useState(null);
  const [isShortSlug, setIsShortSlug] = useState(false);

  // UUID detection regex
  const isUUID = (str) => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(str);
  };

  useEffect(() => {
    const handleRoute = async () => {
      if (!identifier) {
        setLoading(false);
        return;
      }

      // If it's a UUID, check if it's a phlebotomist first, then check labs
      if (isUUID(identifier)) {
        try {
          // First check if it's a phlebotomist (auth.users UUID)
          const { data: phlebData, error: phlebError } = await supabase
            .from('phlebotomist_profiles')
            .select('id, full_name, company_name')
            .eq('id', identifier)
            .single();

          if (phlebData && !phlebError) {
            // It's a phlebotomist - redirect to their dashboard with UUID in URL
            setRedirectTo(`/phlebotomist/${identifier}`);
          } else {
            // If not a phlebotomist, check labs table
            const { data: labData, error: labError } = await supabase
              .from('labs')
              .select('portal_slug, name')
              .eq('id', identifier)
              .single();

            if (labError || !labData) {
              console.error('Neither phlebotomist nor lab found for UUID:', identifier, { phlebError, labError });
              // If no phlebotomist or lab found, redirect to home
              setRedirectTo('/');
            } else if (labData.portal_slug) {
              // Redirect to the branded portal
              setRedirectTo(`/lab-portal/${labData.portal_slug}`);
            } else {
              // Lab exists but no portal_slug, redirect to generic portal login
              setRedirectTo('/lab-portal/login');
            }
          }
        } catch (error) {
          console.error('Error looking up UUID:', error);
          setRedirectTo('/');
        }
      } else {
        // Not a UUID, treat as short slug for lab test directory
        setIsShortSlug(true);
      }

      setLoading(false);
    };

    handleRoute();
  }, [identifier]);

  if (loading) {
    return <div>Loading...</div>;
  }

  // If we need to redirect, do it
  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  // If it's a short slug, render the LabTestDirectory component
  if (isShortSlug) {
    return <LabTestDirectory />;
  }

  // Fallback - shouldn't reach here
  return <Navigate to="/" replace />;
};

export default LabRouteHandler; 